import { SoftwarePackageV2 } from '@models/softwarePackge';
import StopWatch from '@images/SotwarePackages/stop-watch.svg';
import LockShield from '@images/SotwarePackages/lock-shield.svg';
import ExpandArrows from '@images/SotwarePackages/expand-arrows.svg';
import Seatbelt from '@images/SotwarePackages/seatbelt.svg';
import TrafficLight from '@images/SotwarePackages/traffic-light.svg';
import GearMagnifyingGlass from '@images/SotwarePackages/gear-magnifying-glass.svg';
import Lightbulb from '@images/SotwarePackages/lightbulb.svg';
import Leaf from '@images/SotwarePackages/leaf.svg';
import Warranty from '@images/SotwarePackages/warranty.svg';
import Wifi from '@images/SotwarePackages/wifi.svg';
import Device from '@images/SotwarePackages/device.svg';
import Scale from '@images/SotwarePackages/scale.svg';
import Usage from '@images/SotwarePackages/usage.svg';
import Support from '@images/SotwarePackages/support.svg';
import DemoFormBackground from '@images/SiteWideDemoForm/DE-DE.jpg';

export const deSoftwarePackages: SoftwarePackageV2 = {
    version: 2,
    seo: {
        title: 'Softwarepakete | Geotab',
        description:
            'Vergleichen Sie die Funktionen, und wählen Sie Ihren gewünschten Plan für Telematik und Fuhrparkmanagement.',
    },
    getPrices: 'Preise ermitteln',
    demoFormBackgroundImage: DemoFormBackground,
    header: {
        title: 'Unser umfangreichstes Paket für Ihren Bedarf',
        description:
            'Geotab unterstützt Ihren Fuhrpark mit handfesten Lösungen, die Ihre betrieblichen Ziele berücksichtigen und langfristig einen Mehrwert schaffen. Dank umfassender Dateneinblicke und KI können Sie fundierte Entscheidungen treffen, um die Leistung, Sicherheit, Nachhaltigkeit sowie das Kostenmanagement Ihrer Flotte zu verbessern..',
        featured: [
            'Hochwertige Daten. Maximale Aussagekraft',
            'Die Plattform wächst mit Ihren Anforderungen',
            'Lückenlose Datensicherheit',
            'Patentierter Algorithmus für eine hochwertige Datenerfassung',
            'KI und prädiktive Analysemodelle',
            'Personalisierter Support rund um die Uhr',
        ],
        cta: {
            bannerText: 'Mit dem GO-Tarif schöpfen Sie das volle Potenzial der Telematik aus',
            title: 'GO-Tarif',
            subtitle: 'Weltweit',
            description:
                'Der GO-Tarif wurde entwickelt, um verbesserte Daten, umfassendere Einblicke und erweiterte Kompatibilität mit einer breiteren Produktpalette zu vereinen. Der GO-Tarif bietet Kunden maximalen Nutzen innerhalb eines einheitlichen Tarifs.',
        },
    },
    goPlanBenefits: {
        title: 'Funktionen',
        subtitle: 'Der GO-Tarif ermöglicht den Zugriff auf alle Funktionen des GO-Geräts.',
        description:
            'Die komplizierte Verwaltung von Abonnements gehört der Vergangenheit an. Sie erhalten umfassenden Zugriff, um fundierte Entscheidungen für das Fuhrparkmanagement und die Effizienz Ihres Betriebs zu treffen.',
        features: [
            {
                title: 'Komplettes Telematik-Abonnement',
                description:
                    'Sie sind nicht nur an eine Tarifstufe gebunden, sondern können alle Funktionen der Plattform entdecken. Profitieren Sie von einem optimierten Tarif mit weniger Verwaltungsaufwand und mehr Daten.',
                icon: Device,
            },
            {
                title: 'Gesteigerter Mehrwert ohne Einschränkungen',
                description:
                    'Skalieren Sie die Nutzung erweiterter Funktionen und Datenanalysen mühelos mit dem Wachstum Ihres Unternehmens.',
                icon: Scale,
            },
            {
                title: 'Tachograph',
                description: 'Echtzeit-Status und Fahrtenschreiberdaten (TAC). Verstoßmanagement (AFA)',
                icon: Wifi,
            },
            {
                title: 'Übung macht den Meister',
                description:
                    'Je mehr Sie die Plattform nutzen, desto leichter fällt Ihnen die Anwendung. Anleitungen und Tutorials in der Anwendung helfen Ihnen dabei, das Beste aus Ihrer Telematikinvestition herauszuholen.',
                icon: Usage,
            },
            {
                title: 'Austausch mit Fachleuten',
                description:
                    'Unser Support steht Ihnen jederzeit als Unterstützung zur Verfügung. Wir bieten das ganze Jahr über rund um die Uhr Support an.',
                icon: Support,
            },
            {
                title: 'Eingeschränkte lebenslange Gerätegarantie',
                description: 'Schützt vor den Kosten eines Geräteausfalls und gibt Ihnen Sicherheit.',
                icon: Warranty,
            },
        ],
    },
    categories: [
        {
            title: 'Produktivität',
            icon: StopWatch,
            features: [
                'Sofortige GPS-Ortung mit patentierten kurvenbasierten Algorithmen für eine optimale Aufzeichnung',
                'Flexible Engine für Regeln und Ausnahmen – Anpassungen und Bearbeitung möglich',
                'Berichte zu Fahrertreffen',
                'Ortung des nächstgelegenen Fahrzeugs nach Adresse',
                'Fahrerkennung über NFC',
            ],
        },
        {
            title: 'Sicherheit',
            icon: Seatbelt,
            features: [
                'Grundlegendes Fahrercoaching – akustische Signale und Benachrichtigungen bei Geschwindigkeitsüberschreitung, Leerlauf und Fahreridentifikation',
                'Grundlegendes Fahrercoaching und individualisierbare serverseitige Regeön und Ausnahmen',
                'Erweitertes Fahrercoaching – akustische Signale und Benachrichtigungen bei starkem Bremsen, scharfen Kurvenfahrten, überhöhter Beschleunigung, Anlegen des Sicherheitsgurts, Rückwärtsfahren, Überdrehen',
                'Neuer Erkennung von geringfügigen und schwere Kollisionen',
                'Sicherheitscenter: Prädiktive Risikoanalysen und Benchmarking',
            ],
        },
        {
            title: 'Fuhrparkoptimierung',
            icon: GearMagnifyingGlass,
            features: [
                'Nach Zeit oder Entfernung eingeplante Wartungserinnerungen',
                'Nach Kilometerstand oder Motorbetriebsstunden eingeplante Wartungserinnerungen',
                'Einfache Geräteinstallation mit selbstkalibrierendem Beschleunigungsmesser',
                'Motorstatusdaten für alle wichtigen Motorprotokolle (Kraftstoffverbrauch, Spannung, Kühlmittel, Temperatur)',
                'Aufzeichnung und Analyse von Fehlerdaten (J1939, 1708, OBD, CAN)',
                'Geotabs Roadside-Add-In für kostenlosen Abschleppdienst, Schlüsseldienst, Starthilfe, Kraftstofflieferung, Reifenwechsel und mehr',
                'Kraftstoffmanagement – Nachverfolgung von Kraftstoffverbrauch, Kraftstoffablass, Kraftstoffdiebstahl, Integration von Tankkarten',
            ],
        },
        {
            title: 'Erweiterbarkeit',
            icon: ExpandArrows,
            features: [
                'Webbasierte Software-Reporting-Plattform (SAAS) für beliebig viele Fahrzeuge und Benutzer',
                'Unterstützung mehrerer Kartentypen',
                'Umfangreiche Berichtsfunktionen – bilden Trends ab, Bearbeitung und Anpassung möglich',
                'Individualisierbare Dashboards',
                'Flexible Benutzerzugriffssteuerung',
                'Zugriff auf MyGeotab über Android und IOS',
                'SDK und APIs, die offen, kostenlos und benutzerfreundlich sind',
                'Zugriff auf Partner-Add-Ons und -lösungen über den Geotab Marketplace',
                'Eingeschränkte lebenslange Gerätegarantie',
                'Einfache IOX-Zusatzanwendung (IOX-GOTALK, IOX_AUXM, IOX-BUZZ, IOX-NFCREADERA) zur Integration in Peripheriegeräte und Geräte innerhalb des Fahrzeugs',
                'Erweitertes IOX-Add-On (IOX-BT, IOX-USB, IOX-CAN, IOX-WRKS und Add-Ons für Streugeräte IOX-RS232M/F/D) zur Integration in Peripheriegeräte und Geräte innerhalb des Fahrzeugs',
                'Aktive Ortung – hochwertige Tracking-Lösung, die Standortinformationen mit höherer Frequenz und Präzision liefert',
            ],
        },
        {
            title: 'Konformität',
            icon: TrafficLight,
            features: [
                'Manipulationserkennung des Geräts',
                'App für Fahrer (Geotab Drive), skalierbar für zukünftige Anforderungen',
                'HOS-Konformität über Geotab Drive (Android/IOS)',
                'DVIR-Konformität über Geotab Drive (Android/IOS)',
                'IFTA-Meilen-Aufzeichnung',
                'Privatmodus',
            ],
        },
        {
            title: 'Nachhaltigkeit',
            icon: Leaf,
            features: [
                'Eignungsbeurteilung für Elektrofahrzeuge (EVSA)',
                'Beurteilung der Infrastruktur für Elektrofahrzeuge (EVIA)',
                'Verbrauchte Antriebsenergie des Elektrofahrzeugs',
                'Batterieladung des Elektrofahrzeugs % (SOC)',
                'Ladeenergie des Elektrofahrzeugs',
                'Ladezustand des Elektrofahrzeugs',
            ],
        },
        {
            title: 'Innovation',
            icon: Lightbulb,
            features: ['Generative KI', 'Routenplanung und - optimierung', 'Geotab Data Connector'],
        },
        {
            title: 'Datenschutz und Sicherheit',
            icon: LockShield,
            features: [
                'Ein verantwortungsbewusster Rahmen für datenschutzorientierte Ergebnisse',
                'FIPS 140-2-Validierung',
                'FedRamp-Autorisierung',
                'ISO-IEC 27001:2013',
                'UNECE 155/156',
                'Zahlreiche Unternehmen weltweit mit Fokus auf Sicherheit vertrauen uns',
            ],
        },
    ],
};
